'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _addExecuteQuery = require('./addExecuteQuery');

Object.defineProperty(exports, 'addExecuteQuery', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_addExecuteQuery).default;
  }
});

var _deleteItem = require('./deleteItem');

Object.defineProperty(exports, 'deleteItem', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_deleteItem).default;
  }
});

var _fetchViewer = require('./fetchViewer');

Object.defineProperty(exports, 'fetchViewer', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_fetchViewer).default;
  }
});

var _getItem = require('./getItem');

Object.defineProperty(exports, 'getItem', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_getItem).default;
  }
});

var _getList = require('./getList');

Object.defineProperty(exports, 'getList', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_getList).default;
  }
});

var _saveItem = require('./saveItem');

Object.defineProperty(exports, 'saveItem', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_saveItem).default;
  }
});

var _searchPerson = require('./searchPerson');

Object.defineProperty(exports, 'searchPerson', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_searchPerson).default;
  }
});

var _uploadFile = require('./uploadFile');

Object.defineProperty(exports, 'uploadFile', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_uploadFile).default;
  }
});

var _uploadFiles = require('./uploadFiles');

Object.defineProperty(exports, 'uploadFiles', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_uploadFiles).default;
  }
});

var _uploadListItemFile = require('./uploadListItemFile');

Object.defineProperty(exports, 'uploadListItemFile', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_uploadListItemFile).default;
  }
});

var _uploadListItemFiles = require('./uploadListItemFiles');

Object.defineProperty(exports, 'uploadListItemFiles', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_uploadListItemFiles).default;
  }
});

var _deleteListItemFile = require('./deleteListItemFile');

Object.defineProperty(exports, 'deleteListItemFile', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_deleteListItemFile).default;
  }
});
exports.getAvatarUrlByEmail = getAvatarUrlByEmail;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @param {string} email
 * @return {string} url
 */
function getAvatarUrlByEmail(email) {
  return email && window._spPageContextInfo.webAbsoluteUrl + '/_layouts/15/userphoto.aspx?size=s&accountname=' + email;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/ntnu-react/util/sp/index.js
// module id = 160
// module chunks = 0